module.exports = __webpack_public_path__ + "img/headbg-4.664509b1.png";